var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m15 3.33c1.84 0 3.33 1.5 3.33 3.34v6.66c0 1.84-1.49 3.34-3.33 3.34h-10c-1.84 0-3.33-1.5-3.33-3.34v-6.66c0-1.84 1.49-3.34 3.33-3.34zm-3.33 1.67h-3.34v10h3.34zm1.66 0v10h1.67c0.92 0 1.67-0.75 1.67-1.67v-6.66c0-0.92-0.75-1.67-1.67-1.67zm-8.33 10h1.66v-10h-1.66c-0.92 0-1.67 0.75-1.67 1.67v6.66c0 0.92 0.75 1.67 1.67 1.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard12);
export default __webpack_public_path__ + "static/media/board12.ff682aafedc59e12caab28c6326aba5b.svg";
export { ForwardRef as ReactComponent };